import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import { PostHogProvider } from 'posthog-js/react';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import App from './App';

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
  loaded: (posthog: any) => {
    if (import.meta.env.DEV) {
      console.log('PostHog loaded in development mode');
    }
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={posthogOptions}
    >
      <HelmetProvider>
        <BrowserRouter>
          <Toaster position="top-right" />
          <App />
          <Analytics />
          <SpeedInsights />
        </BrowserRouter>
      </HelmetProvider>
    </PostHogProvider>
  </React.StrictMode>
);